var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusPlanned(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_172413",
    transform: "translate(376.967 -788.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85288",
    d: "M-360,798.8c-3.9,0-7,3.2-7,7c0,2,0.9,3.9,2.4,5.3c1.3,1.1,2.9,1.8,4.6,1.8h0.2c3.8-0.1,6.9-3.2,6.9-7 c0-1.8-0.7-3.4-1.8-4.7C-356.1,799.6-358,798.8-360,798.8z M-354.8,806.9c-0.5,2.2-2.3,3.9-4.5,4.2c-0.2,0-0.5,0-0.7,0 c-0.2,0-0.5,0-0.7,0c-2.6-0.4-4.6-2.6-4.6-5.2c0-2.9,2.4-5.3,5.3-5.3c2.5,0,4.7,1.8,5.2,4.2c0.1,0.4,0.1,0.7,0.1,1.1 C-354.7,806.2-354.7,806.6-354.8,806.9L-354.8,806.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85289",
    d: "M-356.3,790.6h-1.3v-0.9c0-0.5-0.5-0.9-1-0.9c-0.5,0-0.9,0.4-0.9,0.9v0.9h-11.1v-0.9c0-0.5-0.5-0.9-1-0.9 c-0.5,0-0.9,0.4-0.9,0.9v0.9h-1.3c-1.8,0-3.3,1.4-3.3,3.2v15.9c0,1.8,1.5,3.2,3.3,3.2h3.6c0.5,0,0.9-0.4,0.9-0.9 c0-0.5-0.4-0.9-0.9-0.9h-3.6c-0.8,0-1.4-0.6-1.5-1.4v-15.9c0-0.8,0.7-1.4,1.5-1.4h1.3v0.9c0,0.5,0.5,0.9,1,0.9 c0.5,0,0.9-0.4,0.9-0.9v-0.9h11.1v0.9c0,0.5,0.5,0.9,1,0.9c0.5,0,0.9-0.4,0.9-0.9v-0.9h1.3c0.8,0,1.4,0.6,1.5,1.4v1.9 c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9v-1.9C-353,792-354.5,790.6-356.3,790.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85290",
    d: "M-357,807l-2.4-1.5v-2.8c0-0.4-0.3-0.7-0.7-0.7c-0.4,0-0.7,0.3-0.7,0.7v3.2c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0v0c0,0,0,0,0,0v0c0,0,0,0,0,0v0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l2.7,1.7 c0.1,0.1,0.2,0.1,0.4,0.1c0.2,0,0.4-0.1,0.5-0.3C-356.6,807.6-356.7,807.2-357,807z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusPlanned);
export default __webpack_public_path__ + "static/media/status_planned.9028ef064eab2d279620e872ac31a892.svg";
export { ForwardRef as ReactComponent };